<div class="lookup-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-left">
      <button mat-icon-button
              *ngIf="isCreateMode && !startInCreateMode"
              (click)="exitCreateMode()"
              class="back-button"
              matTooltip="Back to browse">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h2>{{ isCreateMode ? 'Create New Entry' : title }}</h2>
    </div>
    <div class="header-right">
      <button mat-stroked-button
              color="primary"
              *ngIf="allowCreate && !isCreateMode"
              (click)="enterCreateMode()"
              class="create-new-button">
        <mat-icon>add</mat-icon>
        Create New
      </button>
      <button mat-icon-button (click)="onCancel()" class="close-button">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Browse Mode Content -->
  <ng-container *ngIf="!isCreateMode">
    <!-- Filter Section (dialog mode) -->
    <div class="filter-section" *ngIf="filterColumns.length > 0 && filterDisplayMode !== 'inline'">
    <div class="filter-header">
      <span class="filter-title">Filters</span>
      <div class="filter-actions">
        <button mat-stroked-button
                color="primary"
                (click)="addFilterRow()"
                *ngIf="filterRows.length === 0">
          <mat-icon>filter_list</mat-icon>
          Add Filter
        </button>
        <button mat-stroked-button
                color="warn"
                (click)="clearFilters()"
                *ngIf="filterRows.length > 0">
          Clear All
        </button>
      </div>
    </div>

    <!-- Filter Rows -->
    <div class="filter-rows" *ngIf="filterRows.length > 0">
      <div class="filter-row" *ngFor="let filterRow of filterRows; let i = index">
        <!-- Field Selection -->
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Field</mat-label>
          <mat-select [(ngModel)]="filterRow.fieldName"
                      (selectionChange)="onFilterFieldChange(filterRow)">
            <mat-option *ngFor="let col of filterColumns" [value]="col.fieldName">
              {{ col.displayName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Match Mode -->
        <mat-form-field appearance="outline" class="filter-mode" *ngIf="filterRow.fieldName">
          <mat-label>Match</mat-label>
          <mat-select [(ngModel)]="filterRow.matchMode">
            <mat-option *ngFor="let mode of filterRow.availableMatchModes"
                        [value]="mode.value">
              {{ mode.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Value Input (Text) -->
        <mat-form-field appearance="outline" class="filter-value"
                        *ngIf="filterRow.fieldName && !isDateTimeFilterRow(filterRow)">
          <mat-label>Value</mat-label>
          <input matInput [(ngModel)]="filterRow.value" placeholder="Enter value...">
        </mat-form-field>

        <!-- Value Input (Date) -->
        <mat-form-field appearance="outline" class="filter-value"
                        *ngIf="filterRow.fieldName && isDateTimeFilterRow(filterRow)">
          <mat-label>Date</mat-label>
          <input matInput
                 [matDatepicker]="picker"
                 [(ngModel)]="filterRow.dateValue"
                 (dateChange)="onFilterDateChange(filterRow)"
                 placeholder="Select date...">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <!-- Remove Button (hidden for preset filters) -->
        <button mat-icon-button color="warn" (click)="removeFilterRow(i)" class="remove-filter-btn">
          <mat-icon>delete</mat-icon>
        </button>
      </div>

      <!-- Filter Action Buttons -->
      <div class="filter-row-actions">
        <button mat-stroked-button color="primary" (click)="addFilterRow()">
          <mat-icon>add</mat-icon>
          Add Filter
        </button>
        <button mat-raised-button color="primary" (click)="applyFilters()">
          <mat-icon>search</mat-icon>
          Apply Filters
        </button>
      </div>
    </div>
  </div>

  <!-- Inline Filters (shown above table when filterDisplayMode is 'inline') -->
  <div class="inline-filters" *ngIf="filterColumns.length > 0 && filterDisplayMode === 'inline'">
    <div class="inline-filter-chips">
      <div class="inline-filter-chip" *ngFor="let filterRow of filterRows; let i = index">

        <mat-form-field appearance="outline" class="inline-filter-field" subscriptSizing="dynamic">
          <mat-select [(ngModel)]="filterRow.fieldName"
                      (selectionChange)="onInlineFilterFieldChange(filterRow)"
                      placeholder="Field">
            <mat-option *ngFor="let col of filterColumns" [value]="col.fieldName">
              {{ col.displayName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <ng-container *ngIf="isDateTimeFilterRow(filterRow); else lookupInlineTextInput">
          <mat-form-field appearance="outline" class="inline-filter-value" subscriptSizing="dynamic">
            <input matInput
                   [matDatepicker]="inlinePicker"
                   [(ngModel)]="filterRow.dateValue"
                   (dateChange)="onInlineFilterDateChange(filterRow)"
                   placeholder="Date" />
            <mat-datepicker-toggle matSuffix [for]="inlinePicker"></mat-datepicker-toggle>
            <mat-datepicker #inlinePicker></mat-datepicker>
          </mat-form-field>
        </ng-container>
        <ng-template #lookupInlineTextInput>
          <mat-form-field appearance="outline" class="inline-filter-value" subscriptSizing="dynamic"
                          *ngIf="filterRow.fieldName">
            <input matInput
                   [(ngModel)]="filterRow.value"
                   (ngModelChange)="onInlineFilterValueChange()"
                   placeholder="Value" />
          </mat-form-field>
        </ng-template>

        <button mat-icon-button (click)="removeInlineFilter(i)"
                class="inline-remove-btn" matTooltip="Remove filter">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <button mat-stroked-button (click)="addInlineFilter()" class="inline-add-btn">
        <mat-icon>add</mat-icon>
        Add
      </button>
      <button mat-button (click)="clearInlineFilters()" *ngIf="hasActiveFilters" class="inline-clear-btn">
        Clear
      </button>
    </div>
  </div>

  <!-- Table Section -->
  <div class="table-section">
    <!-- Loading State -->
    <div class="loading-state" *ngIf="isLoading">
      <mat-spinner diameter="40"></mat-spinner>
      <span>Loading data...</span>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!isLoading && tableData.length === 0">
      <mat-icon>search_off</mat-icon>
      <span>No records found</span>
      <span class="empty-hint" *ngIf="hasActiveFilters">Try adjusting your filters</span>
    </div>

    <!-- Table -->
    <div class="table-container" *ngIf="!isLoading && tableData.length > 0">
      <!-- Scrollable Table Wrapper -->
      <div class="table-scroll-wrapper">
        <table class="lookup-table">
          <thead>
            <tr>
              <th *ngFor="let col of displayColumns; trackBy: trackByColumn">
                {{ col.displayName }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of tableData; let i = index"
                [class.selected]="isRowSelected(i)"
                (click)="onRowClick(row, i)">
              <td *ngFor="let col of displayColumns; trackBy: trackByColumn">
                {{ formatCellValue(row[col.fieldName], col.dataType) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Results Count -->
      <div class="results-count">
        {{ tableData.length }} record(s) found
        <span *ngIf="hasActiveFilters">(filtered)</span>
      </div>
    </div>
  </div>
  </ng-container>

  <!-- Create Mode Content -->
  <div class="create-section" *ngIf="isCreateMode">
    <!-- Error Message -->
    <div class="create-error" *ngIf="createError">
      <mat-icon>error</mat-icon>
      <span>{{ createError }}</span>
    </div>

    <!-- Create Form -->
    <div class="create-form">
      <div class="form-fields">
        <div class="form-field" *ngFor="let field of createFormFields; trackBy: trackByField">
          <!-- Text/Number Input -->
          <mat-form-field appearance="outline"
                          *ngIf="!isCreateFieldDateType(field) && !isCreateFieldReferenceType(field) && !isCreateFieldBooleanType(field)">
            <mat-label>{{ field.displayName }}</mat-label>
            <input matInput
                   [(ngModel)]="field.value"
                   [type]="isNumericType(field.dataType) ? 'number' : 'text'"
                   [required]="field.isRequired"
                   [placeholder]="'Enter ' + field.displayName.toLowerCase()">
            <mat-hint *ngIf="field.isRequired">Required</mat-hint>
          </mat-form-field>

          <!-- Date Input -->
          <mat-form-field appearance="outline" *ngIf="isCreateFieldDateType(field)">
            <mat-label>{{ field.displayName }}</mat-label>
            <input matInput
                   [matDatepicker]="createPicker"
                   [(ngModel)]="field.dateValue"
                   (dateChange)="onCreateFormDateChange(field)"
                   [required]="field.isRequired"
                   placeholder="Select date">
            <mat-datepicker-toggle matSuffix [for]="createPicker"></mat-datepicker-toggle>
            <mat-datepicker #createPicker></mat-datepicker>
            <mat-hint *ngIf="field.isRequired">Required</mat-hint>
          </mat-form-field>

          <!-- Reference/Dropdown Input -->
          <mat-form-field appearance="outline" *ngIf="isCreateFieldReferenceType(field)">
            <mat-label>{{ field.displayName }}</mat-label>
            <mat-select [(ngModel)]="field.value"
                        [required]="field.isRequired"
                        [disabled]="field.isLoadingOptions">
              <mat-option *ngIf="field.isLoadingOptions" disabled>
                Loading options...
              </mat-option>
              <mat-option *ngFor="let opt of field.referenceOptions" [value]="opt.value">
                {{ opt.label }}
              </mat-option>
            </mat-select>
            <mat-hint *ngIf="field.isRequired">Required</mat-hint>
          </mat-form-field>

          <!-- Boolean Input -->
          <div class="boolean-field" *ngIf="isCreateFieldBooleanType(field)">
            <mat-checkbox [(ngModel)]="field.value">
              {{ field.displayName }}
            </mat-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Dialog Footer -->
  <div class="dialog-footer">
    <!-- Browse Mode Footer -->
    <ng-container *ngIf="!isCreateMode">
      <div class="selection-info" *ngIf="selectedRow">
        <mat-icon>check_circle</mat-icon>
        <span>Selected: <strong>{{ selectedRow[data.displayField] }}</strong></span>
      </div>
      <div class="dialog-actions">
        <button mat-stroked-button (click)="onCancel()">Cancel</button>
        <button mat-raised-button
                color="primary"
                (click)="onConfirm()"
                [disabled]="!selectedRow">
          Select
        </button>
      </div>
    </ng-container>

    <!-- Create Mode Footer -->
    <ng-container *ngIf="isCreateMode">
      <div class="create-info">
        <mat-icon>info</mat-icon>
        <span>Fill in the fields and click Create to add a new entry</span>
      </div>
      <div class="dialog-actions">
        <button mat-stroked-button
                *ngIf="!startInCreateMode"
                (click)="exitCreateMode()"
                [disabled]="isCreating">
          Back to Browse
        </button>
        <button mat-stroked-button
                *ngIf="startInCreateMode"
                (click)="onCancel()"
                [disabled]="isCreating">
          Cancel
        </button>
        <button mat-raised-button
                color="primary"
                (click)="createNewEntry()"
                [disabled]="!isCreateFormValid() || isCreating">
          <mat-spinner *ngIf="isCreating" diameter="18" class="button-spinner"></mat-spinner>
          <span *ngIf="!isCreating">Create</span>
          <span *ngIf="isCreating">Creating...</span>
        </button>
      </div>
    </ng-container>
  </div>
</div>
